import * as t from "io-ts";
import { CheckoutOption } from "./CheckoutOption";
import { Customer } from "./Customer";
import { FlowType } from "./FlowType";
import { JobItem } from "./JobItem";
import { Metadata } from "./Metadata";
import { Money } from "./Money";
import { RedirectURLs } from "./RedirectURLs";
import { WorkType } from "./WorkType";

export const InfoCheckoutRedirect = t.intersection([
  t.type({
    reference: t.string,
    work_type: WorkType,
    deposit_type: t.union([
      t.literal("no_deposit"),
      t.literal("partial_deposit"),
      t.literal("fixed_deposit"),
    ]),
    deposit_value: Money,
    customer: Customer,
    job_items: t.array(JobItem),
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    oid: t.string,
    aid: t.string,
    eid: t.string,
    bid: t.string,
    tid: t.string,
    flow_type: FlowType,
    checkout_options: t.array(CheckoutOption),
    enabled_rates: t.array(t.string),
    redirect_urls: RedirectURLs,
    metadata: Metadata,
  }),
]);

export interface InfoCheckoutRedirect {
  id?: string;
  cid?: string;
  oid?: string;
  aid?: string;
  eid?: string;
  bid?: string;
  tid?: string;
  flow_type?: FlowType;
  checkout_options?: Array<CheckoutOption>;
  reference: string;
  work_type: WorkType;
  enabled_rates?: Array<string>;
  deposit_type: "no_deposit" | "partial_deposit" | "fixed_deposit";
  deposit_value: Money;
  customer: Customer;
  job_items: Array<JobItem>;
  redirect_urls?: RedirectURLs;
  metadata?: Metadata;
}
